import RequestManager from "src/requests/RequestManager";
import { Match } from "../interfaces";
import { allMatches, isMockDataActive } from "../mockData";
import { ScheduleTask } from "../tasks";
import { parseMatch } from "../utils";

// Se usa en NodoMundial/Calendario
export default async function getAllMatches(): Promise<Match[]> {
    if(isMockDataActive) {
        return allMatches;
    }
    const timeFrom1 = "2022-11-20";
    const timeTo1 = "2022-11-30";
    const timeFrom2 = "2022-11-30";
    const timeTo2 = "2022-12-10";
    const timeFrom3 = "2022-12-10";
    const timeTo3 = "2022-12-20";

    const task1 = new ScheduleTask(timeFrom1, timeTo1);
    const task2 = new ScheduleTask(timeFrom2, timeTo2);
    const task3 = new ScheduleTask(timeFrom3, timeTo3);

    const result1 = (await RequestManager.addRequest(task1)).matches || [];
    const result2 = (await RequestManager.addRequest(task2)).matches || [];
    const result3 = (await RequestManager.addRequest(task3)).matches || [];

    const results = [...result1, ...result2, ...result3];
    return results.map(match => parseMatch(match))
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getAllMatches.ts